import {
  API_COMPLETE_VANTAGE_ENDPOINT,
  CALLBACK_REQUEST_ENDPOINT,
  INITIATE_CALLBACK_REQUEST,
  COMPLETE_CALLBACK_REQUEST,
  MEDIA_TYPE_IS_ARTICLE,
  MEDIA_TYPE_IS_VIDEO,
  IMAGE_BASE_LINK,
  INITIATE_EVENT_DOWNLOAD_PDF_PROCESS,
  COMPLETE_EVENT_DOWNLOAD_PDF_PROCESS,
  FAILURE_EVENT_DOWNLOAD_PDF_PROCESS,
  API_DOWNLOAD_EVENT_PDF_ENDPOINT,
  API_INITIATE_VANTAGE_ENDPOINT,
  API_SEND_EMAIL_EVENT_ENDPOINT,
  API_VANTAGE_ENDPOINT,
  COMPLETE_EMAIL_EVENT_REPORT,
  FAILURE_EMAIL_EVENT_REPORT,
  INITIATE_EMAIL_EVENT_REPORT,
  START_EVENT_RESOURCE_TRACK,
  COMPLETE_EVENT_RESOURCE_TRACK,
  API_EVENT_TRACK_RESOURCE_ENDPOINT,
  UPDATE_SELECTED_SLIDES,
  HIDE_GENERIC_ERROR_MODAL,
  TCOM_VANTAGE_URL,
  DEBUG_MODE,
  OPEN_CALLBACK_REQUEST_MODAL,
  CLOSE_CALLBACK_REQUEST_MODAL,
} from '../../app-constants';
import { apiGet, apiPost, apiFilePost } from '../../api/api-configuration';
import { failureAction, getQueryStringHashToObject, downloadFileBlob } from '../../app-actions';
import { omnitureTriggerEventAction, omnitureTriggerError } from '../../utilities/omniture-data-layer';

export const successVantage = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_VANTAGE_ENDPOINT, data };
};

export const failureVantage = (error) => {
  const errorMessage = sessionStorage.getItem('errorMessage');
  if ((errorMessage === 'userDidNotAttend' || errorMessage === 'userDoesNotExist') && DEBUG_MODE !== true) {
    window.location = TCOM_VANTAGE_URL;
  } else {
    failureAction(error);
  }
  return {
    type: '',
    data: {},
  };
};

export const getVantageEndpoint = (endpoint, data) => {
  const parsedHash = getQueryStringHashToObject(data);
  const {
    userId,
    eventId,
    pageId,
  } = parsedHash;
  if (userId !== undefined) {
    return `${endpoint}?eventId=${eventId}&userId=${userId}&pageId=${pageId}`;
  }
  return `${endpoint}?eventId=${eventId}`;
};

export const getVantage = data => (dispatch) => {
  const endpoint = getVantageEndpoint(API_VANTAGE_ENDPOINT, data);
  dispatch({ type: API_INITIATE_VANTAGE_ENDPOINT });
  apiGet(dispatch, endpoint, successVantage, failureVantage, data);
};

export const successCallbackRequest = (response) => {
  omnitureTriggerEventAction('requestCallback');
  return {
    type: COMPLETE_CALLBACK_REQUEST,
    data: response,
  };
};

export const failureCallbackRequest = (response) => {
  omnitureTriggerError('T:000361');
  return {
    type: COMPLETE_CALLBACK_REQUEST,
    data: response,
  };
};

export const openCallbackRequestModal = () => ({ type: OPEN_CALLBACK_REQUEST_MODAL });
export const closeCallbackRequestModal = () => ({ type: CLOSE_CALLBACK_REQUEST_MODAL });

export const sendCallbackRequest = (data, eventId) => (dispatch) => {
  const endpoint = `${CALLBACK_REQUEST_ENDPOINT}?eventId=${eventId}`;
  dispatch({ type: INITIATE_CALLBACK_REQUEST });
  apiPost(dispatch, endpoint, successCallbackRequest, failureCallbackRequest, data);
};

const prepareArticle = (article, buttonText, clickAction, uId, index) => {
  const imageUrl = `${IMAGE_BASE_LINK}/${article.id}.jpg`;
  return { ...article, buttonText, imageUrl, clickAction, mediaType: MEDIA_TYPE_IS_ARTICLE, uId, index };
};

const prepareHighlightsVideo = (video, buttonText, clickAction, relatedContentHeadingText, uId, index) => (
  {
    ...video,
    buttonText,
    clickAction,
    relatedContentHeadingText,
    uId,
    index,
  }
);

export const prepareVideoArticles = (videoArticlesList, clickAction, relatedContentHeadingText, uId, index) => videoArticlesList
  .map((videoArticle, videoArticleIndex) => prepareHighlightsVideo(
    videoArticle, null, clickAction, relatedContentHeadingText,
    uId, index || videoArticleIndex, // 'index' comes from prepareTrendingArticles, otherwise just use the default index supplied by map
  ));

export const prepareArticles = (articles, clickAction, uId) => articles.map(article => prepareArticle(article, null, clickAction, uId));

export const prepareTrendingArticles = (
  articleList,
  readArticleButtonText,
  watchVideoButtonText,
  eventsTrackResourceViewsClickHandler,
  relatedContentHeadingText,
  uId,
) => articleList.map((article, index) => {
  const isTrendingArticle = true;
  if (article.mediaType === MEDIA_TYPE_IS_ARTICLE) {
    return { ...prepareArticle(article, readArticleButtonText, eventsTrackResourceViewsClickHandler, uId, index) };
  }
  if (article.mediaType === MEDIA_TYPE_IS_VIDEO) {
    return {
      ...prepareHighlightsVideo(
        article, watchVideoButtonText, eventsTrackResourceViewsClickHandler, relatedContentHeadingText, uId, index,
      ),
      isTrendingArticle,
    };
  }
  return null;
});

export const prepareConversationArticles = ({
  articles,
  customContent,
  callbackRequested,
  callbackRequest,
  uId,
}) => {
  const articlesWithoutAEContent = articles.slice(1);
  if (uId) {
    // articles with AE Content included
    return articles.map((article, articleIndex) => {
      if (articleIndex === 0) {
        return {
          ...article,
          articleHasAeContent: true,
          customContent,
          callbackRequested,
          callbackRequest,
        };
      }
      return article;
    });
  }
  return articlesWithoutAEContent;
};


export const successDownloadEventPdfProcess = (response) => {
  omnitureTriggerEventAction('downloadFile');
  downloadFileBlob(response, 'trip-report.pdf', 'application/pdf');
  return ({ type: COMPLETE_EVENT_DOWNLOAD_PDF_PROCESS });
};

export const failureDownloadEventPdfProcess = () => {
  omnitureTriggerError('T:000359');
  return { type: FAILURE_EVENT_DOWNLOAD_PDF_PROCESS };
};

export const startEventDownloadPdfProcess = (data, eventId) => (dispatch) => {
  const endpoint = `${API_DOWNLOAD_EVENT_PDF_ENDPOINT}?eventId=${eventId}`;
  dispatch({ type: INITIATE_EVENT_DOWNLOAD_PDF_PROCESS });
  apiFilePost(dispatch, endpoint, successDownloadEventPdfProcess, failureDownloadEventPdfProcess, data);
};

export const getEventUserId = () => {
  const parsedHash = getQueryStringHashToObject(window.location.hash);
  return parsedHash.userId;
};

export const getEventId = () => {
  const parsedHash = getQueryStringHashToObject(window.location.hash);
  return parsedHash.eventId;
};

export const successEmailEventReport = () => {
  omnitureTriggerEventAction('shareFile');
  return { type: COMPLETE_EMAIL_EVENT_REPORT };
};

export const failureEmailEventReport = () => {
  omnitureTriggerError('T:000360');
  return { type: FAILURE_EMAIL_EVENT_REPORT };
};

export const emailEventReport = (data, eventId) => (dispatch) => {
  const endpoint = `${API_SEND_EMAIL_EVENT_ENDPOINT}?eventId=${eventId}`;
  dispatch({ type: INITIATE_EMAIL_EVENT_REPORT });
  apiFilePost(dispatch, endpoint, successEmailEventReport, failureEmailEventReport, data);
};

export const hideGenericErrorModal = () => ({ type: HIDE_GENERIC_ERROR_MODAL });

export const successEventsTrackResource = () => ({ type: COMPLETE_EVENT_RESOURCE_TRACK });

export const eventsTrackResourceViews = data => (dispatch) => {
  dispatch({ type: START_EVENT_RESOURCE_TRACK });
  apiFilePost(dispatch, API_EVENT_TRACK_RESOURCE_ENDPOINT, successEventsTrackResource, failureAction, data);
};

export const getPageType = () => {
  const parsedHash = getQueryStringHashToObject(window.location.hash);
  let pageType = 'unrestricted';
  if (parsedHash.pageId) {
    if (parsedHash.pageId.toLowerCase() === 'tripreport') {
      pageType = 'tripReport';
    } else if (parsedHash.pageId.toLowerCase() === 'followup') {
      pageType = 'followUp';
    } else if (parsedHash.pageId.toLowerCase() === 'unattended') {
      pageType = 'unattended';
    }
  }
  return pageType;
};

export const updateSelectedSlides = data => (dispatch) => {
  dispatch({ type: UPDATE_SELECTED_SLIDES, data });
};

export const stripStartingAndEndingPTags = (htmlText) => {
  const trimmedHtmlText = htmlText.trim();
  const htmlTextWithoutStartingAndEndingPTags = trimmedHtmlText.substring(3, trimmedHtmlText.length - 4);
  return htmlTextWithoutStartingAndEndingPTags;
};
